













import { Component, InjectComponent, Prop, Vue, VueComponent, FlowStep } from "@zoovu/runner-browser-api";

@Component({})
export default class AdviceFiltersView extends Vue {
  @InjectComponent("FilterPanelView")
  filterPanelView: VueComponent;

  @Prop()
  filters!: FlowStep[];

  onResetFilters(): void {
    this.$emit("reset-all-filters");
  }
}
